import axios from 'axios';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.withCredentials = true;
export default class QuoteService {
    getDropDownList(param) {        
        var result = axios.post(process.env.VUE_APP_APIPath + 'Utility/getDDL', param).then((res) => res.data);
        return result;
    }

    saveQuoteData(param){
        var result = axios.post(process.env.VUE_APP_APIPath + 'GetQuote/SubmitGetQuote', param).then((res) => res.data);
        return result;
    }
}